import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TOfferKind } from '@recruitee/http/types';

@Component({
  selector: 'rt-offer-status-indicator',
  templateUrl: './offer-status-indicator.component.html',
  styleUrls: ['./offer-status-indicator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'statusType',
  },
})
export class OfferStatusIndicatorComponent {
  @Input() public offerStatus: { kind: TOfferKind; status: string };

  public get statusType(): string {
    if (this.offerStatus.kind === 'talent_pool') {
      return 'talent-pool';
    } else {
      return this.offerStatus.status;
    }
  }
}
